import { Button } from '@apollo/space-kit/Button';
import { colors } from '@apollo/space-kit/colors';
import React from 'react';

import { PermissionWarning } from 'src/components/permissionGuards/permissionWarning/PermissionWarning';
import { ContactSupportLink } from 'src/components/support-request/contactSupportLink/ContactSupportLink';

import { raw as ImageObservatoryColor } from './observatory-color.svg';
interface Props {
  accountId: string;
}

export const ExpiredTeamTrial = ({ accountId }: Props) => {
  return (
    <div className="relative flex size-full items-center justify-center">
      <div className="max-w-md px-4 text-center">
        <img src={ImageObservatoryColor} alt="Observatory" />
        <div className="mt-6 text-3xl font-semibold">
          Where did the time go? Looks like your Team trial has ended.
        </div>
        <div className="mt-4 text-lg">
          Contact us to keep access to all the advanced features of the Apollo
          platform, like schema validation and the client registry.{' '}
          <div className="mt-6">
            <PermissionWarning
              accountId={accountId}
              accountPermissions="canSetConstrainedPlan"
              childRenderer={(hasPermission) => (
                <div className="flex flex-col justify-center gap-4">
                  <Button
                    type="button"
                    disabled={!hasPermission}
                    color={colors.indigo.dark}
                    as={
                      hasPermission ? (
                        <ContactSupportLink className="cursor-pointer" />
                      ) : undefined
                    }
                    className="mx-auto w-40"
                  >
                    Contact us
                  </Button>
                </div>
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
